const floorStatics = {
  p0_m: {
    sectionPath: '/floor_0m',
    locationKey: 'p0_m',
    sectionKey: 'MAN',
    floorKey: '0m',
    section: 'p0_m.section.name',
    floor: 'p0_m.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_ARE_ARESE_SHOPPING_CENTER_IMG.jpg?ts=1631201500000',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0m',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_m.path.floorMap.linkName',
        title: 'p0_m.path.floorMap.title',
        info: 'p0_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.floorMap.description.title',
          content: 'p0_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p0_m.path.shoes.linkName',
        title: 'p0_m.path.shoes.title',
        info: 'p0_m.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_Calzado.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.shoes.description.title',
          content: 'p0_m.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_m.path.pickUpSize.linkName',
        title: 'p0_m.path.pickUpSize.title',
        info: 'p0_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_EncuentraTalla.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_m.path.pickUpSize.description.title',
          content: 'p0_m.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_m.path.selfCheckout.linkName',
        title: 'p0_m.path.selfCheckout.title',
        info: 'p0_m.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_Autocobro.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.selfCheckout.description.title',
          content: 'p0_m.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p0_m.path.fittingRooms.linkName',
        title: 'p0_m.path.fittingRooms.title',
        info: 'p0_m.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_M_TurnoProbadores.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.fittingRooms.description.title',
          content: 'p0_m.path.fittingRooms.description.content',
        },
      },
    ],
  },
  p0_w: {
    sectionPath: '/floor_0w',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0w',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_ARE_ARESE_SHOPPING_CENTER_IMG.jpg?ts=1631201500000',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_W.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0w',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p0_w.path.lingerie.linkName',
        title: 'p0_w.path.lingerie.title',
        info: 'p0_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_W_Lenceria_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P0_W_Lenceria.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.lingerie.description.title',
          content: 'p0_w.path.lingerie.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN',
    floorKey: '1',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 1',
    img_banner:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_ARE_ARESE_SHOPPING_CENTER_IMG.jpg?ts=1631201500000',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p1_w.path.beauty.linkName',
        title: 'p1_w.path.beauty.title',
        info: 'p1_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_Beauty_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_Beauty.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.beauty.description.title',
          content: 'p1_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p1_w.path.onlinePickup.linkName',
        title: 'p1_w.path.onlinePickup.title',
        info: 'p1_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_PuntoRecogidaOnline.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.onlinePickup.description.title',
          content: 'p1_w.path.onlinePickup.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p1_w.path.shoes.linkName',
        title: 'p1_w.path.shoes.title',
        info: 'p1_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_Calzado.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.shoes.description.title',
          content: 'p1_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p1_w.path.selfCheckout.linkName',
        title: 'p1_w.path.selfCheckout.title',
        info: 'p1_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_Autocobro.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.selfCheckout.description.title',
          content: 'p1_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p1_w.path.pickUpSize.linkName',
        title: 'p1_w.path.pickUpSize.title',
        info: 'p1_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.pickUpSize.description.title',
          content: 'p1_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p1_w.path.fittingRooms.linkName',
        title: 'p1_w.path.fittingRooms.title',
        info: 'p1_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/6437_P1_W_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.fittingRooms.description.title',
          content: 'p1_w.path.fittingRooms.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'it-IT',
    name: 'Italiano',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/6437_ARE_ARESE_SHOPPING_CENTER_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
